import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

const storedLanguage = localStorage.getItem('preferredLanguage');

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: storedLanguage === 'es' || storedLanguage === 'en' ? storedLanguage : 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
